import React from 'react';
import SvgIcon from 'components/SvgIcon';

const ErrorGearIcon = ({ className, height = '512', width = '512' }) => (
  <SvgIcon
    className={className}
    width={width}
    height={height}
    fill="transparent"
    viewBox="0 0 512 512"
  >
    <rect width="512" height="512" fill="#F3F3F3" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M159 142.996L110.732 191.264C109.794 192.202 109.268 193.474 109.268 194.8C109.268 196.126 109.794 197.398 110.732 198.336L137.652 225.256C134.686 231.133 132.192 237.254 130.128 243.556H92C89.2386 243.556 87 245.794 87 248.556V321.444C87 324.206 89.2386 326.444 92 326.444H130.128C132.192 332.746 134.686 338.867 137.652 344.744L110.732 371.664C109.794 372.602 109.268 373.874 109.268 375.2C109.268 376.526 109.794 377.798 110.732 378.736L162.264 430.268C164.217 432.221 167.383 432.221 169.336 430.268L196.259 403.344C202.127 406.301 208.245 408.814 214.556 410.876V449C214.556 451.761 216.794 454 219.556 454H292.444C295.206 454 297.444 451.761 297.444 449V410.876C303.755 408.814 309.873 406.301 315.741 403.344L342.664 430.268C344.617 432.221 347.783 432.221 349.736 430.268L401.268 378.736C403.221 376.783 403.221 373.617 401.268 371.664L374.348 344.744C377.314 338.867 379.808 332.746 381.872 326.444H420C422.761 326.444 425 324.206 425 321.444V248.556C425 245.794 422.761 243.556 420 243.556H381.872C379.808 237.254 377.314 231.133 374.348 225.256L401.268 198.336C403.221 196.383 403.221 193.217 401.268 191.264L349.736 139.732C348.798 138.794 347.526 138.268 346.2 138.268C345.792 138.268 345.389 138.317 345 138.414V151.539L346.2 150.339L390.661 194.8L364.677 220.784C363.11 222.352 362.761 224.763 363.821 226.71C367.794 234.012 370.964 241.814 373.408 249.988C374.041 252.105 375.988 253.556 378.198 253.556H415V316.444H378.198C375.988 316.444 374.041 317.895 373.408 320.012C370.964 328.186 367.794 335.988 363.821 343.29C362.761 345.237 363.11 347.648 364.677 349.216L390.661 375.2L346.2 419.661L320.216 393.677C318.651 392.112 316.244 391.762 314.298 392.816C306.98 396.781 299.176 399.985 291.022 402.405C288.9 403.035 287.444 404.985 287.444 407.198V444H224.556V407.198C224.556 404.985 223.1 403.035 220.978 402.405C212.824 399.985 205.02 396.781 197.702 392.816C195.756 391.762 193.349 392.112 191.784 393.677L165.8 419.661L121.339 375.2L147.323 349.216C148.89 347.648 149.239 345.237 148.179 343.29C144.206 335.988 141.036 328.186 138.592 320.012C137.959 317.895 136.012 316.444 133.802 316.444H97V253.556H133.802C136.012 253.556 137.959 252.105 138.592 249.988C141.036 241.814 144.206 234.012 148.179 226.71C149.239 224.763 148.89 222.352 147.323 220.784L121.339 194.8L159 157.139V142.996Z"
      fill="#4A4A4A"
    />
    <mask
      id="mask0"
      mask-type="alpha"
      maskUnits="userSpaceOnUse"
      x="164"
      y="58"
      width="166"
      height="325"
    >
      <rect x="164" y="58" width="166" height="325" fill="white" />
    </mask>
    <g mask="url(#mask0)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M260.3 63V105.578L236.5 129.378L212.7 105.578V63C191.696 72.1868 177 93.0951 177 117.478C177 141.861 191.696 162.77 212.7 171.956V282.805C212.7 294.669 220.804 305.653 232.502 307.557C247.412 309.984 260.3 298.537 260.3 284.078V171.956C281.303 162.77 296 141.861 296 117.478C296 93.0951 281.303 72.1868 260.3 63Z"
        stroke="#4A4A4A"
        strokeWidth="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M316.5 282.5V202.5H326.5L316.5 172.5H296.5L286.5 202.5H296.5V282.5H286.5V352.5C286.5 363.54 295.46 372.5 306.5 372.5C317.54 372.5 326.5 363.54 326.5 352.5V282.5H316.5Z"
        stroke="#4A4A4A"
        strokeWidth="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </SvgIcon>
);

export default ErrorGearIcon;
